import { observer } from 'mobx-react';
import React, { useEffect } from 'react';

import { Rules, SpinCentered } from '@/comp';
import { useStores } from '@/hooks/use-stores';

const RulesPage = observer(() => {
  const { stationStore, rulesStore, devicesStore } = useStores();

  useEffect(() => {
    if (!stationStore.currentStation.id) return;
    rulesStore.get(stationStore.currentStation.id);
    devicesStore.getDevicesMetadata();
  }, [stationStore.currentStation.id]);

  const isReady = () => {
    return stationStore.currentStation.id && devicesStore.isReady;
  };

  return isReady() ? <Rules rules={rulesStore.rules} /> : <SpinCentered />;
});

export default RulesPage;
